import { FC } from 'react';
import { ILocale } from '@/lang/types';
import Icon24 from './icon-24';
import { IconButton } from '@mui/material';
import { checkIsRtl } from '@/lang/utils';
import { useIntl } from 'react-intl';
import { useRouter } from 'next/router';

const BackwardIcon = '/icons/dialog/backward.svg';

interface BackwardButtonProps {
  handleClick: () => void;
  disabled?: boolean;
}

export const BackwardButton: FC<BackwardButtonProps> = ({
  handleClick,
  disabled = false,
}) => {
  const intl = useIntl();
  const { locale } = useRouter();
  const isRtl = checkIsRtl(locale as ILocale);

  return (
    <IconButton
      id={'back-icon'}
      aria-label={intl.formatMessage({
        id: 'images.title.backward',
      })}
      disabled={disabled}
      onClick={handleClick}
      sx={{
        position: 'absolute',
        top: 8,
        left: 8,
        transform: isRtl ? 'rotate(180deg)' : 'none',
        opacity: disabled ? 0.4 : 1,
      }}
    >
      <Icon24 icon={BackwardIcon} title='alt.backward_icon' />
    </IconButton>
  );
};
